<template>
  <div v-if="showComponent" class="card card-material card-type">
    <div @click="openFilter()" class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div class="card-title card-material-title" :class="{ 'clear-select': filterDeliveryProgram }">
        Leverprogramma
        <div v-if="filterDeliveryProgram" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && filterDeliveryProgram" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter" class="select-type row">
        <div v-for="filter in filters" v-bind:key="filter" v-on:click.stop.prevent="select(filter)" class="card card-select card-body card-filter col-md-6 m-md-1" :class="{ 'selected': filter === filterDeliveryProgram }">
          <div class="card-type">
            <div class="large">
              {{ filter }}
            </div>
            <div class="small">
              <template v-if="filter === 'POM'">Uitgebreide paneel keuze</template>
              <template v-if="filter === 'Easy W'">Melamine panelen<br/>5 werkdagen levertijd</template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_FILTER_DELIVERYPROGRAM, SET_MATERIAL_FILTER_FIRST, SET_MATERIAL_FILTER_SECOND, SET_MATERIAL_FILTER_THIRD, SET_MATERIAL_THICKNESS, SET_MATERIAL_PRODUCT } from '../../../store/types'
  import { EventBus } from '../../../bus'

  export default {
    data() {
      return {
        showFilter: false
      }
    },
    computed: {
      selectedName() {
        if (this.filterDeliveryProgram) {
          return this.filterDeliveryProgram
        }

        return ''
      },
      filterFirst() {
        return this.$store.getters.filterFirst
      },
      filterDeliveryProgram() {
        return this.$store.getters.filterDeliveryProgram
      },
      isActive() {
        return this.showFilter || (!this.filterDeliveryProgram && !this.$store.getters.filterFirst)
      },
      filters() {
        if (this.$store.getters.filterFirst) {
          let filterFirst = this.$store.getters.filterFirst

          let products = this.products.filter((product) => product.filter_1 === filterFirst)

          // Only get second filters
          let filters = products.map(product => product.deliveryprogram)

          // Make sure we get the distinct filters
          filters = [...new Set(filters.sort((a, b) => a - b))]

          // If only 1 option is left, just pre-select the item, and move on
          if (filters.length === 1) {
            this.select(filters[0])
          }

          return filters
        }

        return []
      },
      products() {
        return this.$store.getters.products
      },
      material() {
        return !this.$store.getters.material ? false : this.$store.getters.material
      },
      showComponent() {
        return this.filterFirst && this.filters.length > 0 && this.filters[0] !== '' && this.filters[0] !== 'Meubelpanelen'
      }
    },
    methods: {
      select(select) {
        if (select !== this.filterDeliveryProgram) {
          // Reset the other material filters
          this.$store.dispatch(SET_MATERIAL_FILTER_SECOND, null)
          this.$store.dispatch(SET_MATERIAL_FILTER_THIRD, null)
          this.$store.dispatch(SET_MATERIAL_THICKNESS, null)
          this.$store.dispatch(SET_MATERIAL_PRODUCT, null)

          // Update the material filter
          this.$store.dispatch(SET_MATERIAL_FILTER_DELIVERYPROGRAM, select)

          EventBus.$emit('filterfirst-select-one')
        }
        this.showFilter = false
      },
      openFilter() {
        if (this.filterDeliveryProgram && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.filterDeliveryProgram) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.filterDeliveryProgram) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.filterDeliveryProgram
    }
  }
</script>

<style lang="scss" scoped>
  .card-filter {
    padding: 10px 5px;
    word-break: keep-all;

    .large {
      font-size: 125%;
    }
    .small {
      word-break: break-word;
    }
  }
</style>
